import styles from './IconMenu.module.scss';

export const IconMenu = () => <div className={styles.IconMenu} />;
